import { render, staticRenderFns } from "./DepartmentStorePointPanel.vue?vue&type=template&id=5d914d68&"
import script from "./DepartmentStorePointPanel.vue?vue&type=script&lang=ts&"
export * from "./DepartmentStorePointPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports